import fetcher from '@/utils/fetcher';

const completeLicenseForTier1 = async ({
  businessId,
  facilityId,
  licenseNumber,
}: {
  businessId: string;
  facilityId: string;
  licenseNumber: string;
}): Promise<undefined> => {
  return await fetcher({
    endpoint: `/businesses/${businessId}/facility/${facilityId}/complete-license`,
    method: 'POST',
    body: JSON.stringify({ licenseNumber }),
  });
};

export default completeLicenseForTier1;
